'use client'

import React, { useCallback, useEffect, useState } from 'react'
import NextLink from 'next/link'
import NextImage from 'next/image'

import Button from '@/components/Button'
import {
	LeftArrowIcon,
	LinkIcon,
	MailIcon,
	RightArrowIcon,
	TelegramIcon,
	UpRightArrowIcon,
	VkIcon
} from '@/components/Icon'
import Typography from '@/components/Typography'

import styles from '../../styles.module.css'
import IconButton from '@/components/IconButton'
import useEmblaCarousel from 'embla-carousel-react'
import { EmblaCarouselType } from 'embla-carousel'
import ShareSection from '../ShareSection'
import Link from '@/components/Link'
import ImagesCarousel from '../ImagesCarousel'
import ArticleImages from '../ArticleImages'

const similarCases: any[] = [
	// {
	//   img: "/passport.jpeg",
	//   href: "#",
	//   badge: "Образование",
	//   title: "Внедрение искусственного интеллекта (AI)",
	//   description:
	//     "Сервис для создания сопроводительного письма в иммиграционную службу",
	// },
	// {
	//   img: "/vehicle.png",
	//   href: "#",
	//   badge: "Производство",
	//   title: "Цифровизация завода",
	//   description:
	//     "Крупнейший производитель вездеходов в Восточной Сибири и на Дальнем Востоке",
	// },
]

export default function Article7() {
	return (
		<>
			<article className={styles.article}>
				<section className={styles.article__section}>
					<Typography variant='h2' className={styles.article__headline}>
						Задача:
					</Typography>
					<Typography variant='p1'>
						Как правило, производственное оборудование имеет относительно длительный срок эксплуатации в сочетании
						с жесткими нормативными требованиями. Это требует, чтобы существующие системы и процессы были
						оптимизированы с помощью цифровых технологий.
					</Typography>
					<Typography variant='p1'>
						Пищевое производство, основанное на наших технологиях, должно ускорять текущие базовые процессы и
						производительность за счет расширенной аналитики, точной потоковой передачи данных и мониторинга
						процессов.
					</Typography>
					<Typography variant='p1'>
						Мы должны были наладить управление производством, которое обеспечивало бы прозрачность
						производственных операций, ускорение физического потока производственных линий, повышение пропускной
						способности цеха и общей эффективности оборудования и людей.
					</Typography>
				</section>
				<section className={styles.article__section}>
					<Typography variant='h2' className={styles.article__headline}>
						Выполненные работы:
					</Typography>
					<Typography variant='p1'>
						Произведен аудит производства, систем учета и безопасности пищевого производства.
					</Typography>

					<ArticleImages
						images={[
							{
								src: require('../../../../../../public/images/portfolio/7-1.jpg').default,
								placeholder: 'blur'
							}
						]}
						scaleDown
					/>
					<Typography variant='p1'>
						Доработан и внедрен программный комплекс системы учета сырья и готовой продукции.
					</Typography>
					<ArticleImages
						images={[
							{
								src: require('../../../../../../public/images/portfolio/7-2.jpg').default,
								placeholder: 'blur'
							}
						]}
						scaleDown
					/>
					<Typography variant='p1'>
						Внедрена автоматизированная система создания и хранения технологических карт.
					</Typography>
					<ArticleImages
						images={[
							{
								src: require('../../../../../../public/images/portfolio/7-3.jpg').default,
								placeholder: 'blur'
							}
						]}
						scaleDown
					/>
					<Typography variant='p1'>Для исключения недостачи определены зоны контроля сотрудников.</Typography>
					<ArticleImages
						images={[
							{
								src: require('../../../../../../public/images/portfolio/7-4.jpg').default,
								placeholder: 'blur'
							}
						]}
						scaleDown
					/>
					<Typography variant='p1'>
						Внедрена и интегрирована с ERP предприятия автоматизированная система складского и бухгалтерского
						учета.
					</Typography>
					<ArticleImages
						images={[
							{
								src: require('../../../../../../public/images/portfolio/7-5.jpg').default,
								placeholder: 'blur'
							}
						]}
						scaleDown
					/>
				</section>
				<section className={styles.article__section}>
					<Typography variant='h2' className={styles.article__headline}>
						Результат:
					</Typography>
					<Typography variant='p1'>
						Цифровая трансформация стала бизнес-драйвером производства. Развертывание и интеграция новых
						технологий на базе предприятия позволили повысить эффективность процессов. Разделили ручные и
						автоматизированные процессы, в каждый из которых, внедрили ИТ-решения для их улучшения.
					</Typography>
				</section>

				<ShareSection />
			</article>

			{similarCases.length > 0 && (
				<section className={`${styles.similar__projects}`}>
					<Typography variant='h2'>Похожие проекты</Typography>
					<div className={`${styles.cases__cards}`}>
						{similarCases.slice(0).map(({ img, href, badge, description, title }, idx) => (
							<div className={styles.case} key={idx}>
								<div className={styles.card}>
									<NextImage
										className={styles['card-image']}
										src={img}
										alt=''
										fill
										priority
										sizes='(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw'
									/>
									<div className={styles.badge}>{badge}</div>
									<div className={styles['card-hover']}>
										<div className={styles['card-hover__content']}>
											<span className={styles['card-hover__text-small']}>Ознакомиться с кейсом</span>
											{/* <span className={styles["card-hover__text-big"]}>x3</span>{" "}
                      <span className={styles["card-hover__text-small"]}>
                        Рост конверсии
                      </span>
                      <span className={styles["card-hover__text-big"]}>60</span>{" "}
                      <span className={styles["card-hover__text-small"]}>
                        Часов работы
                      </span> */}
											<IconButton
												Icon={UpRightArrowIcon}
												variant='circle'
												className={styles['card-hover__button']}
											/>
										</div>
									</div>
								</div>
								<Typography variant='h5' className={styles.case__headline}>
									{title}
								</Typography>
								<Typography variant='p2' color='description' className={styles.case__description}>
									{description}
								</Typography>
							</div>
						))}
					</div>
				</section>
			)}
		</>
	)
}
